<template>
  <v-card class="card">
    <h2 class="card-title">{{ data.name }}</h2>
    <div class="card-content">
      <v-row justify="center">
        <v-col cols="auto">
          <v-chip :color="siteStatusColor">{{ siteStatus }}</v-chip>
        </v-col>
      </v-row>
      <v-row class="bikes-infos">
        <v-col md="6">
          <info-box class="is-full-width" :label="$t('siteStatus.availableRent')" :value="data.available"></info-box>
        </v-col>
        <v-col md="6">
          <info-box class="is-full-width" :label="$t('siteStatus.availableReturn')" :value="seatsRemain"></info-box>
        </v-col>
      </v-row>
      <div class="site-infos">
        <div class="site-info-item">
          <div class="info-header">{{ $t('siteStatus.powerStatus') }}：</div>
          <div class="info-content">{{ powerStatus }}</div>
        </div>
        <div class="site-info-item">
          <div class="info-header">{{ $t('siteStatus.address') }}：</div>
          <div class="info-content">{{ data.address }}</div>
        </div>
        <div class="site-info-item">
          <div class="info-header">{{ $t('siteStatus.maintenance') }}：</div>
          <div class="info-content">{{ data.maintenanceDept }}</div>
        </div>
        <div class="site-info-item space-between" v-if="isNormal">
          <div class="info-header">{{ $t('siteStatus.dispatch') }}：</div>
          <div class="info-content">
            <v-switch class="site-switch" v-model="data.dispatch"></v-switch>
          </div>
        </div>
        <div class="site-info-item space-between" v-if="isNormal">
          <div class="info-header">{{ $t('siteStatus.closed') }}：</div>
          <div class="info-content">
            <v-switch class="site-switch" v-model="data.suspended"></v-switch>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { SITE_STATUS, POWER_STATUS } from '@/libs/enum'
import InfoBox from '@/components/Share/InfoBox'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  components: { InfoBox },
  computed: {
    isNormal () {
      return this.type === 'normal'
    },
    seatsRemain () {
      const { bikeRacks, available } = this.data
      return bikeRacks - available
    },
    siteStatusColor () {
      return this.data.state ? 'success' : 'error'
    },
    siteStatus () {
      return this.$t(`siteStatusDict.${SITE_STATUS[this.data.state]}`)
    },
    powerStatus () {
      return this.$t(`powerStatusDict.${POWER_STATUS[this.data.power]}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .card
    padding 30px

  .card-title
    width 100%
    text-align center
    font-size 30px

  .site-status
    display block
    width fit-content
    margin 0 auto
    padding 6px 30px
    border-radius 16px

  .site-info-item
    display flex
    align-items center
    font-size 20px
    margin 24px 0
    &:not(:last-of-type)
      margin-bottom 24px
    &.space-between
      justify-content space-between
      margin-bottom 0

  .site-switch
    margin-top 0
    padding-top 0
    .v-input__slot
      margin-bottom 0
    &/deep/ .v-messages
      display none
</style>
